import { configureStore } from "@reduxjs/toolkit";
import assetModelSlice from "./slices/asset-model.slice";
import assetTypeSlice from "./slices/asset-type";
import assetSlice from "./slices/asset.slice";
import baselineSlice from "./slices/baseline.slice";
import certificateSlice from "./slices/certificate.slice";
import dashboardSlice from "./slices/dashboard.slice";
import dmsDashboardSlice from "./slices/dms-dashboard.slice";
import dmsDeviceSlice from "./slices/dms-device.slice";
import driverModelSlice from "./slices/driver-model.slice";
import burnTimeReportSlice from "./slices/fault-module/burn-time-report.slice";
import energyReportSlice from "./slices/fault-module/energy-report.slice";
import environmentalReportSlice from "./slices/fault-module/environmental-report.slice";
import faultReportSlice from "./slices/fault-module/fault-report.slice";
import motionHeatMapReportSlice from "./slices/fault-module/motion-heat-map-report.slice";
import motionTrafficReportSlice from "./slices/fault-module/motion-traffic-report.slice";
import testReportSlice from "./slices/fault-module/test-report.slice";
import userActivityReportSlice from "./slices/fault-module/user-activity.slice";
import faultSlice from "./slices/fault.slice";
import floorSlice from "./slices/floor.slice";
import locationBlockSlice from "./slices/location-block.slice";
import displayLocationSlice from "./slices/display-location.slice";
import locationSiteSlice from "./slices/location-site.slice";
import navbarReducer from "./slices/navbar.slice";
import navConfigSlice from "./slices/navconfig.slice";
import otaSlice from "./slices/ota.slice";
import pendingApprovalSlice from "./slices/pending-approval.slice";
import reportConfigurationSlice from "./slices/report-configuration.slice";
import roleSlice from "./slices/role.slice";
import scheduleSlice from "./slices/schedule.slice";
import slsSlice from "./slices/sls.slice";
import tableSlice from "./slices/table.slice";
import testSlice from "./slices/test.slice";
import townCouncilSlice from "./slices/town-council.slice";
import notificationSlice from "./slices/notification.slice";
import userSlice from "./slices/user.slice";
import alertConfigurationSlice from "./slices/alert-configuration.slice";
import otpSlice from "./slices/mfa-otp.slice";
import routeStateSlice from "./slices/route-state.slice";
import floorLocationSlice from "./slices/location.slice";
import masterConfigurationSlice from "./slices/master-configuration.slice";
import analyticsSlice from "./slices/analytics.slice";
import simCardSlice from "./slices/sim-card.slice";
import uploadProgressSlice from "./slices/upload-progress.slice";

export const store = configureStore({
  reducer: {
    navbar: navbarReducer,
    navConfig: navConfigSlice,
    dashboard: dashboardSlice,
    user: userSlice,
    notification: notificationSlice,
    pendingApproval: pendingApprovalSlice,
    role: roleSlice,
    sls: slsSlice,
    fault: faultSlice,
    townCouncil: townCouncilSlice,
    locationBlock: locationBlockSlice,
    displayLocation: displayLocationSlice,
    assetModel: assetModelSlice,
    driverModel: driverModelSlice,
    asset: assetSlice,
    schedule: scheduleSlice,
    dmsDevice: dmsDeviceSlice,
    ota: otaSlice,
    baseline: baselineSlice,
    reportConfiguration: reportConfigurationSlice,
    dmsDashboard: dmsDashboardSlice,
    certificate: certificateSlice,
    locationSite: locationSiteSlice,
    test: testSlice,
    faultReport: faultReportSlice,
    burnTimeReport: burnTimeReportSlice,
    motionTrafficReport: motionTrafficReportSlice,
    motionHeatMapReport: motionHeatMapReportSlice,
    energyReport: energyReportSlice,
    testReport: testReportSlice,
    userActivityReport: userActivityReportSlice,
    environmentalReport: environmentalReportSlice,
    assetType: assetTypeSlice,
    floor: floorSlice,
    table: tableSlice,
    alertConfiguration: alertConfigurationSlice,
    otp: otpSlice,
    routeState: routeStateSlice,
    floorLocation: floorLocationSlice,
    masterConfiguration: masterConfigurationSlice,
    analytics: analyticsSlice,
    simCard: simCardSlice,
    uploadProgress: uploadProgressSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
